export default {"src":"/_next/static/media/linkedin-social.1a7f4f97.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};